/**
 * RETOMAR LO QUE ARGEMIRO YA PREGUNTO POR WHATSAPP (ONB-FICHA-MOVIL-T1).
 *
 * QUE PASABA. Josse abrio el enlace del cuestionario en el celular despues de hablar con
 * Argemiro por WhatsApp y la ficha arrancaba con "Hola, soy Argemiro, como te llamas?": la
 * conversacion empezaba de cero aunque el nombre ya estaba dado. Y al re-hidratar, la ficha
 * repetia TODA la conversacion anterior, que en un celular es una pared de texto.
 *
 * LA REGLA: si ya sabemos algo, se saluda por el nombre, se dice EN UNA LINEA lo que ya
 * tenemos, y se sigue por lo que falta. Nada de repreguntar lo que ya vino.
 *
 * El contenido de lo ya sabido sale del state del token (lo llena A en
 * ONB-CONTINUIDAD-WA-T1); aqui no se inventa nada: si llega vacio, no hay retoma.
 *
 * Sin DOM: lo prueba scripts/check-onboard-movil.mjs.
 */

const lleno = (v) => v !== null && v !== undefined && String(v).trim() !== '';

/** Los campos que ya tenemos, en el orden en que se piden. */
export function loQueYaSe(capturado, campos) {
  const lista = Array.isArray(campos) ? campos : [];
  return lista.filter((k) => lleno(capturado?.[k]));
}

/** Hay algo con que retomar? (el nombre solo tambien cuenta) */
export function hayRetoma(capturado, campos) {
  return loQueYaSe(capturado, campos).length > 0;
}

/**
 * El saludo de retoma, o null si no hay nada que retomar.
 * @param {object} capturado lo que vino del state del token
 * @param {string[]} campos los campos requeridos, en orden
 * @param {(k:string)=>string} etiqueta como se llama cada campo en cristiano
 */
export function saludoDeRetoma(capturado, campos, etiqueta) {
  const ya = loQueYaSe(capturado, campos);
  if (ya.length === 0) return null;

  const nombre = String(capturado?.ownerName || '').trim();
  const saludo = nombre ? `Hola de nuevo, ${nombre} 👋` : 'Hola de nuevo 👋';

  const nombres = ya.filter((k) => k !== 'ownerName').map((k) => etiqueta(k));
  const primeros = nombres.slice(0, 3);
  const resto = nombres.length - primeros.length;
  const loQue = primeros.length === 0
    ? 'Ya tengo tu nombre.'
    : `Ya tengo ${primeros.join(', ')}${resto > 0 ? ` y ${resto} dato${resto === 1 ? '' : 's'} mas` : ''}.`;

  return `${saludo} ${loQue} Sigamos con lo que falta.`;
}

/** El progreso dicho corto, para que quepa en un celular. */
export function progresoCorto(capturado, campos) {
  const total = Array.isArray(campos) ? campos.length : 0;
  const hechos = loQueYaSe(capturado, campos).length;
  const faltan = Math.max(0, total - hechos);
  if (total === 0) return '';
  if (faltan === 0) return 'Listo, no falta nada';
  return `Falta${faltan === 1 ? '' : 'n'} ${faltan} de ${total}`;
}

/**
 * Lo tecnico (el token, la lista completa de campos) es para quien depura, no para el
 * cliente: se muestra solo con ?dev=1 en el enlace o con una sesion de administrador.
 */
export function muestraLoTecnico({ hash = '', busqueda = '', esAdmin = false } = {}) {
  const texto = `${hash} ${busqueda}`;
  return esAdmin === true || /[?&]dev=1(\b|&|$)/.test(texto);
}
